/* import __COLOCATED_TEMPLATE__ from './dropdown.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./dropdown.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());